'use strict';

var slickHomeBanner = slickHomeBanner || {};
var $ = jQuery;

/* INIT
 ----------------------------------------------------------------------------------------------------------------------*/
slickHomeBanner.init = function () {
  slickHomeBanner.start();
}

/* DOM READY
 ----------------------------------------------------------------------------------------------------------------------*/
$(slickHomeBanner.init);

/* FUNCTIONS
 ----------------------------------------------------------------------------------------------------------------------*/
slickHomeBanner.start = function () {

  // console.log('slickHomeBanner');

  // SLIDER HOME BANNER
  var homeProduct = $(".field--field-background-image.header__field-background-image");

  // homeProduct.addClass('container');

  homeProduct.slick({
    autoplay:true,
    speed: 1600,
    fade: true,
    cssEase: 'linear',
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });

};